import createCanonical from "./createCanonical";

export { createCanonical };
